export default __webpack_public_path__ + "static/media/blog-img126.6f89304a.jpg";